



























import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';

import {
  updateSubJobAmount,
} from '@/api';

import updateAmountModal from '@/table/Job/SubJob/update-amount-modal';
import assemblyUpdateAmountModal from '@/table/Job/SubJob/assembly-update-amount-modal';
import useSubJob from '@/use/useSubJob';

const CommonModalWithAmountStatusUpdate = defineComponent({
  props: {
    module: { default: 'qc' },
  },
  setup(props, { emit }) {
    const modal = ref(null);
    const {
      translateSubJobStatus, sumSubJobStatusAmount,
      statusToQCAmountColumn, translateQCStatus,
      statusToAssemblyAmountColumn, translateAssemblyStatus,
    } = useSubJob();
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const computedModuleFunction = computed(() => {
      if (props.module === 'assembly') return { table: assemblyUpdateAmountModal, statusToAmount: statusToAssemblyAmountColumn, translate: translateAssemblyStatus };
      return { table: updateAmountModal, statusToAmount: statusToQCAmountColumn, translate: translateQCStatus };
    });

    function compose(payload: any) {
      form.text = payload?.text;
      form.items = payload.items.map((item: any) => ({
        ...item,
        currentStatusAmount: item[computedModuleFunction.value.statusToAmount(form.text)] || 0,
        [computedModuleFunction.value.statusToAmount(form.text)]: 0,
      }));
      form.status = payload?.status;
      form.qc_status = payload?.qc_status;
      form.process_status = payload?.process_status;
      form.assembly_status = payload?.assemblyStatus;
      form.old_column = payload?.old_column;
      (modal.value as any).open();
    }

    function getMaxStatusAmount(item: any) {
      if (form.old_column === 'amount') return item.amount - sumSubJobStatusAmount({ ...item, qc_progress_amount: item.currentStatusAmount });
      return item.amount - sumSubJobStatusAmount({ ...item, [statusToQCAmountColumn(form.text)]: item.currentStatusAmount }) + (item[(form as any).old_column] || 0) + (props.module === 'assembly' ? item[computedModuleFunction.value.statusToAmount(form.text)] : 0);
    }

    const form = reactive({
      items: [],
      status: null,
      qc_status: null,
      process_status: null,
      assembly_status: null,
      text: '',
      old_column: null,
      call: async () => {
        await updateSubJobAmount({
          items: form.items.map((item: any) => ({
            id: item.id,
            [computedModuleFunction.value.statusToAmount(form.text)]: item[computedModuleFunction.value.statusToAmount(form.text)],
            qc_start_date: item.qc_start_date,
            qc_finish_date: item.qc_finish_date,
          })),
          status: form.status,
          qc_status: form.qc_status,
          process_status: form.process_status,
          assembly_status: form.assembly_status,
          old_column: form.old_column,
        });
        emit('done');
        (modal.value as any).close();
      },
    });

    return {
      computedModuleFunction,
      getMaxStatusAmount,

      toCurrencyWithoutSign,
      translateQCStatus,
      statusToQCAmountColumn,
      translateSubJobStatus,
      sumSubJobStatusAmount,
      updateAmountModal,
      form,
      modal,
      compose,
    };
  },
});

export default CommonModalWithAmountStatusUpdate;
